function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.regexp.constructor.js";
import "core-js/modules/es6.object.define-property.js";
var privateMethods = {
  getUrlParameter: function getUrlParameter(params, name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(params);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }
};
export var URLSearchParameters = /*#__PURE__*/function () {
  /**
   * @return {URLSearchParameters}
   */
  function URLSearchParameters(params) {
    _classCallCheck(this, URLSearchParameters);

    this._params = params;
    if (URLSearchParams) this._urlSearchParams = new URLSearchParams(this._params);
    return this;
  }

  _createClass(URLSearchParameters, [{
    key: "get",
    value: function get(name) {
      if (this._params === "") return "";
      return URLSearchParams ? this._urlSearchParams.get(name) : privateMethods.getUrlParameter.call(this._params, name);
    }
  }, {
    key: "has",
    value: function has(name) {
      if (this._params === "") return false;

      if (URLSearchParams) {
        return this._urlSearchParams.has(name);
      } else {
        var param = privateMethods.getUrlParameter.call(this._params, name);
        return param !== undefined;
      }
    }
  }, {
    key: "toString",
    value: function toString() {
      return this._params ? this._params.substr(1) : "";
    }
  }, {
    key: "isValid",
    value: function isValid() {
      return this._params !== "";
    }
  }]);

  return URLSearchParameters;
}();